import { render, staticRenderFns } from "./CampaignMedia.vue?vue&type=template&id=329c93d3&scoped=true"
import script from "./CampaignMedia.vue?vue&type=script&lang=ts"
export * from "./CampaignMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c93d3",
  null
  
)

export default component.exports